export const ORDER_MADE_FOR_LENGTH = '50';
export const SPECIAL_INSTRUCTIONS_LENGTH = '200';
